import TimeVarying from "../ModelMixins/TimeVarying";
import { propertyGetTimeValues } from "../ReactViews/FeatureInfo/getFeatureProperties";
import hashFromString from "./hashFromString";

/**
 * Hashes a Cesium {@link Entity} (used by us for features) by stringifying its properties and name.
 *
 * @param feature The feature to hash
 * @param clock A clock that will be used to resolve the property values.
 * @returns {Number} the hash, as an integer.
 */
export default function hashEntity(feature, terria) {
  var _JSON$stringify, _feature$name;
  const catalogItemTime = feature._catalogItem && TimeVarying.is(feature._catalogItem) ? feature._catalogItem.currentTimeAsJulianDate : undefined;
  return hashFromString(((_JSON$stringify = JSON.stringify(propertyGetTimeValues(feature, catalogItemTime !== null && catalogItemTime !== void 0 ? catalogItemTime : terria.timelineClock.currentTime))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "") + ((_feature$name = feature.name) !== null && _feature$name !== void 0 ? _feature$name : ""));
}